import { render, staticRenderFns } from "./CartaoObservacaoParaCancelamento.vue?vue&type=template&id=7de99cda&scoped=true"
import script from "./CartaoObservacaoParaCancelamento.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoObservacaoParaCancelamento.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de99cda",
  null
  
)

export default component.exports